import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { WorkOrderModel } from '../models/classes/work-order';
import { WorkOrderItemModel } from '../models/classes/work-order-item';
import { TaskModel } from '../models/classes/task';

@Injectable({
  providedIn: 'root',
})

export class WorkorderService {
  ip = environment.ipServer;
  workorders: WorkOrderModel[] = [];
  tasks: Task[] = [];
  allTasks: TaskModel[] = [];
  workitem: WorkOrderItemModel;

  constructor(private http: HttpClient) {}

  getworkorders(): Observable<WorkOrderModel[]> {
    const url = `${this.ip}/api/workorder`;
    return this.http.get<WorkOrderModel[]>(url).pipe(
      map((data) => (this.workorders = data)),
      catchError(this.handleError)
    );
  }

  createWorkOrder(user: string): Observable<number> {
    const url = `${this.ip}/api/workorder/CreateWorkOrder/${user}`;
    return this.http.get<number>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  createTasks(workorderItemmodels:WorkOrderItemModel[]){
    const url = `${this.ip}/api/workorder/createTasks`;
    return this.http
        .post<WorkOrderModel>(url, workorderItemmodels, { observe: 'response' });
  }

  addToWorkOrder(workOrderModel: WorkOrderModel): Subscription {
    const url = `${this.ip}/api/workorder`;
    return this.http
      .post<WorkOrderModel>(url, workOrderModel)
      .subscribe((data) => {
      });
  }

  getTasks(): Observable<TaskModel[]> {
    const url = `${this.ip}/api/task/GetTasks`;
    return this.http.get<TaskModel[]>(url).pipe(
      map((data) => (this.allTasks = data)),
      catchError(this.handleError)
    );
  }

  getSubTasks(taskId: number) {
    const url = `${this.ip}/api/workorder/getsubtasks/${taskId}`;
    return this.http.get<WorkOrderItemModel>(url);
  }

  updateTask(id: number,task: TaskModel){
    const url = `${this.ip}/api/workorder/updatetask/${id}`;
    return this.http.put(url, task, { observe: 'response' });
  }

  deleteTasks(ids: number[]){
    var url = `${this.ip}/api/workorder/deletetask/${ids}`;
    return this.http.delete(url, { observe: 'response' });
  }

  private handleError(err: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
